import { jsxs as l, Fragment as p, jsx as u } from "react/jsx-runtime";
import "react";
import { Typography as d, Callout as m } from "@vp/swan";
import { formatDate as f } from "./help-center-knowledge-anatomies9.js";
import { useTranslation as c } from "./help-center-knowledge-anatomies10.js";
const M = ({ article: e, locale: s, tenant: a = "vistaprint" }) => {
  const { t: r } = c(a);
  if (!e?.lastModifiedDate) return null;
  const o = ((t) => {
    if (!t || t !== "Series" && t !== "How to guide")
      return null;
    const i = `articles.${t}_type`, n = r(i);
    return n === i ? null : n;
  })(e.articleType);
  return /* @__PURE__ */ l(d, { fontSkin: "body-small", textColor: "subtle", children: [
    r("articles.last_updated"),
    " ",
    f(e.lastModifiedDate, s),
    o && /* @__PURE__ */ l(p, { children: [
      " • ",
      /* @__PURE__ */ u(m, { emphasis: "low", children: o })
    ] })
  ] });
};
export {
  M as LastModifiedDate
};
//# sourceMappingURL=help-center-knowledge-anatomies3.js.map
